import type { ReactNode } from "react";

const icons = {
  Home: <path d="m12 2-10 8h3v11h5v-7h4v7h5V10h3L12 2Z" />,
  Raids: (
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 3h4l11 11-4 4L3 7V3Zm0 0 13 13m-3 3 6-6m-2 4 4 4m-1-1 1-1" />
      <path d="m14 8 7-5v4l-5 5M3 21l4-4m-2-4 6 6m-7 1-1-1m4-5 2-2" />
    </g>
  ),
  "Raid planner": (
    <>
      <path
        fillRule="evenodd"
        d="M6 2h2v3h8V2h2v3h2a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2V2ZM4 10v10h16V10H4Z"
      />
      <path d="M6 12h3v2H6zm5 0h3v2h-3zm5 0h2v2h-2zM6 16h3v2H6zm5 0h3v2h-3zm5 0h2v2h-2z" />
    </>
  ),
  Players: (
    <>
      <circle cx="9" cy="7" r="4" />
      <path d="M2 21v-3a7 7 0 0 1 14 0v3H2Zm15-18a4 4 0 0 1 0 8h-1a6 6 0 0 0 0-8h1Zm1 11h1a5 5 0 0 1 5 5v2h-6v-3c0-1.4-.3-2.8-.9-4H18Z" />
    </>
  ),
  Members: (
    <>
      <circle cx="12" cy="7" r="3.5" />
      <circle cx="4" cy="9" r="2.5" />
      <circle cx="20" cy="9" r="2.5" />
      <path d="M6 21v-3a6 6 0 0 1 12 0v3H6ZM0 19v-2a4 4 0 0 1 5-3.9A8 8 0 0 0 4 18v1H0Zm20 0v-1a8 8 0 0 0-1-4.9A4 4 0 0 1 24 17v2h-4Z" />
    </>
  ),
  Professions: <path d="M21.7 3.7a6 6 0 0 1-7.4 7.4L5.4 20a2.4 2.4 0 0 1-3.4-3.4l8.9-8.9a6 6 0 0 1 7.4-7.4L14 4.6 17.4 8l4.3-4.3ZM3.7 17.7a.8.8 0 1 0 1.1 1.1.8.8 0 0 0-1.1-1.1Z" />,
  Loot: (
    <>
      <path
        fillRule="evenodd"
        d="M5 4h14l3 5v12H2V9l3-5Zm1.1 2L4.3 9h15.4l-1.8-3H6.1ZM4 12v7h16v-7h-6v3h-4v-3H4Z"
      />
      <path d="M11 10h2v3h-2z" />
    </>
  ),
  Schedule: (
    <>
      <path
        fillRule="evenodd"
        d="M6 2h2v3h8V2h2v3h2a2 2 0 0 1 2 2v5.5a8 8 0 0 0-2-1.4V10H4v10h7.1a8 8 0 0 0 1.4 2H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2V2Z"
      />
      <circle
        cx="17"
        cy="17"
        r="5"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M17 14v3h2"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  "My guild": (
    <>
      <path
        fillRule="evenodd"
        d="m12 2 9 3v7c0 5-5.4 8.8-9 11-3.6-2.2-9-6-9-11V5l9-3Zm0 2.2L5 6.5V12c0 3.6 3.6 6.6 7 8.7 3.4-2.1 7-5.1 7-8.7V6.5l-7-2.3Z"
      />
      <path d="M9 8h7l-1.5 2L16 12h-5v5H9V8Z" />
    </>
  ),
  "Ask Guildmaster": (
    <path d="M5 3a3 3 0 0 0-3 3v11a3 3 0 0 0 3 3h1v4l5-4h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H5Z" />
  ),
  "Officer Desk": (
    <>
      <path
        fillRule="evenodd"
        d="M6 3h12a4 4 0 0 1 4 4v2h-4v9a3 3 0 0 1-3 3H3v-2h1a2 2 0 0 0 2-2V9H2V7a4 4 0 0 1 4-4Zm2 2v12c0 .7-.2 1.4-.5 2H15a1 1 0 0 0 1-1V7c0-.7.2-1.4.5-2H8ZM4 7h2V5a2 2 0 0 0-2 2Zm14 0h2a2 2 0 0 0-2-2v2Z"
      />
      <path d="M10 9h4v2h-4zm0 4h4v2h-4z" />
    </>
  ),
  Operations: (
    <path
      fillRule="evenodd"
      d="m10 1-.6 3a8 8 0 0 0-2 .9L4.8 3.2 2 6l1.7 2.6a8 8 0 0 0-.8 2L0 11v4l3 .6a8 8 0 0 0 .8 1.8L2 20l2.8 2.8 2.6-1.7a8 8 0 0 0 2 .8l.6 3h4l.6-3a8 8 0 0 0 2-.8l2.6 1.7L22 20l-1.7-2.6a8 8 0 0 0 .8-1.8L24 15v-4l-3-.5a8 8 0 0 0-.8-1.9L22 6l-2.8-2.8-2.6 1.7a8 8 0 0 0-2-.9L14 1h-4Zm2 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10Z"
      transform="translate(1 0) scale(.92)"
    />
  ),
} satisfies Record<string, ReactNode>;

export function NavIcon({ name }: { name: keyof typeof icons }) {
  return (
    <svg
      className="nav-icon"
      viewBox="0 0 24 24"
      width="20"
      height="20"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      {icons[name]}
    </svg>
  );
}
